import React, { useEffect } from 'react';

// Shared layouts
import { Dashboard as DashboardLayout } from 'layouts';

// Component styles
import { makeStyles } from '@mui/styles';
import styles from './style';

import { useNavigate, useParams } from 'react-router-dom';
import { SpeedDial } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { cleanConcentrator } from 'js/actions/concentratorActions';
import { cleanVoltage } from 'js/actions/chargeActions';
import { isAllowed } from 'helpers';
import VoltageTable from './components/VoltageTable';
const useStyle = makeStyles(styles);

export function Voltage() {
  const classes = useStyle();
  const dispatch = useDispatch();
  const { meterId } = useParams();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.user);

  const corpAdmin = useSelector((state) => state.user.corporative);
  const corpUser = user.corporative;
  const corporativeId =
    corpUser === undefined || corpUser === null ? corpAdmin.id : corpUser.id;

  useEffect(() => {
    dispatch(cleanConcentrator());
    dispatch(cleanVoltage());
  }, []);

  return (
    <DashboardLayout>
      <div className={classes.root}>
        <div className={classes.content}>
          <VoltageTable meterId={meterId} corporativeId={corporativeId} />
        </div>
      </div>
      {isAllowed(user.permissions, ['concentrator_create']) && (
        <SpeedDial
          sx={{
            position: 'fixed',
            bottom: 32,
            right: 32,
            '& .MuiFab-primary': {
              backgroundColor: '#00AFEF',
              color: '#fff',
              width: '60px',
              height: '60px',
              fontSize: '1.5em',
              '&:hover': {
                backgroundColor: 'rgb(0, 146, 199)',
              },
            },
          }}
          ariaLabel="SpeedDial basic example"
          icon={<Add />}
          onClick={() => navigate(`/newVoltage/${meterId}`)}
        />
      )}
    </DashboardLayout>
  );
}
